import { render, staticRenderFns } from "./TeamStatusControl.vue?vue&type=template&id=275be6e9&scoped=true"
import script from "./TeamStatusControl.vue?vue&type=script&lang=js"
export * from "./TeamStatusControl.vue?vue&type=script&lang=js"
import style0 from "./TeamStatusControl.vue?vue&type=style&index=0&id=275be6e9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275be6e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('275be6e9')) {
      api.createRecord('275be6e9', component.options)
    } else {
      api.reload('275be6e9', component.options)
    }
    module.hot.accept("./TeamStatusControl.vue?vue&type=template&id=275be6e9&scoped=true", function () {
      api.rerender('275be6e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/TeamStatusControl.vue"
export default component.exports